const getNearestLocation = (lat, lon) => {
  const locations = [
    {
      name: 'Central London',
      latitude: 51.5074,
      longitude: -0.1278,
      vanRun: 'SE',
    },
    { name: 'Bristol', latitude: 51.4545, longitude: -2.5879, vanRun: 'SW' },
    { name: 'Leeds', latitude: 53.8008, longitude: -1.5491, vanRun: 'N' },
  ];

  const toRadians = (degree) => degree * (Math.PI / 180);

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in kilometers
  };

  let nearestLocation = null;
  let nearestVanRun = null;
  let minDistance = Infinity;

  for (const location of locations) {
    const distance = calculateDistance(
      lat,
      lon,
      location.latitude,
      location.longitude
    );
    if (distance < minDistance) {
      minDistance = distance;
      nearestLocation = location.name;
      nearestVanRun = location.vanRun;
    }
  }

  return { vanRun: nearestVanRun, location: nearestLocation };
};

export default getNearestLocation;
